<form>
  <div class="modal-content">
    <!-- <div class="modal-header  position-relative">
      <button type="button"
              class="btn-close"
              (click)="activeModal.dismiss('close')"
              aria-label="Close"><i class="fa-solid fa-xmark"></i></button>
    </div> -->
    <div class="modal-body">
      <div class="container mt-3 mb-3">
        <div>
          <h4 class=" mx-3">{{title}}</h4>
          <h6 class=" mx-3">{{text}}</h6>
        </div>

      </div>
    </div>
    <div class="modal-footer">
      <div class="mt-2 d-flex justify-content-end">
        <button type="button"
                (click)="activeModal.dismiss('yes')"
                routerLinkActive="router-link-active"
                class="btn btn-primary py-1 mx-1 px-4">Yes</button>
        <button type="button"
                (click)="activeModal.dismiss('close')"
                class="btn btn-custom mx-1 py-1 px-4"
                data-bs-dismiss="modal">No</button>

      </div>
    </div>

  </div>
</form>